
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-0a45d796\",\"scoped\":false,\"hasInlineConfig\":false}!scss-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./aboutdetail.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./aboutdetail.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0a45d796\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./aboutdetail.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/aboutdetail.vue
// module id = 154
// module chunks = 0